export const sortLevels = (a, b) => {
  // Ensure we have strings
  const strA = String(a ?? '');
  const strB = String(b ?? '');

  // Handle special cases first
  if (strA === 'Unassigned') return 1;  // Always put Unassigned at the end
  if (strB === 'Unassigned') return -1;

  // Convert to numbers if possible
  const numA = parseFloat(strA);
  const numB = parseFloat(strB);

  // If both are numbers, compare numerically
  if (!isNaN(numA) && !isNaN(numB)) {
    return numA - numB;
  }

  // If one is a number and one isn't, put the number first
  if (!isNaN(numA)) return -1;
  if (!isNaN(numB)) return 1;

  // If neither are numbers, compare as strings
  return strA.localeCompare(strB);
};
